<template>
	<v-dialog v-model="modalOpen" max-width="500px">
		<v-card>
			<!-- <v-card-title>{{ isAuditorRequestReceiver ? 'Invite a Auditor' : 'Invite a Supplier' }}</v-card-title> -->
			<v-card-title>Invite a Auditor</v-card-title>
			<v-card-subtitle v-if="!isAuditRequestReceiver" class="my-2"
				>Enter a name for the invitation code, so you'll find back to it later,
				and an expiry date to set how long the new code should be
				valid</v-card-subtitle
			>
			<v-card-subtitle v-else class="my-2"
				>Enter the name of the auditor you would like to send the onsite audit, and an expiry date to set how long the new code should be
				valid</v-card-subtitle
			>
			<v-card-text>
				<v-form v-model ="valid">
					<v-text-field v-if="!isAuditRequestReceiver"
						align="center"
						label="Name"
						hide-details="auto"
						placeholder="Enter name here"
						outlined
						:rules = notEmptyRules
						v-model="name"
					></v-text-field>
					<v-text-field v-else
						align="center"
						label="Name of Auditor"
						hide-details="auto"
						placeholder="Enter name here"
						outlined
						:rules = notEmptyRules
						v-model="name"
					></v-text-field>
					<v-select
						class="mt-5"
						outlined
						:items="expiryItems"
						label="Expiry date"
						item-text="text"
						item-value="value"
						:rules = notEmptyRules
						v-model="expiry"
					></v-select>
				</v-form>
				<!--
				Comment: Remove do not allow to redeem multiple times
				<v-checkbox v-if="isAuditRequestReceiver == false"
					v-model="multipleRedeem"
					label="Allow Code to be Redeemed Multiple Times"
				></v-checkbox>
				-->
			</v-card-text>
			<v-card-actions>
				<v-btn color="primary" text :disabled="!valid" v-on:click="createCode()" outlined
					>Create</v-btn
				>
				<v-btn color="error" text v-on:click="modalOpen = false" outlined
					>Cancel</v-btn
				>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import InvitationcodeAPI from "../../api/connections/invitationcodes"
import LoadingState from "../../consts/LoadingState"
import { mapActions } from "vuex"
export default {

	props: {
		isAuditRequestReceiver: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			expiry: null,
			name: null,
			valid: false,
			multipleRedeem: false,
			notEmptyRules: [(v) => !!v || "This field cannot be empty"],
		}
	},
	computed: {
		expiryItems() {
			return [
				{
					text: "1 month (30 days)",
					value: 2592000000, //Add a month
				},
				{
					text: "3 months (90 days)",
					value: 7776000000, //Add 3 months
				},
				{
					text: "6 months (180 days)",
					value: 15552000000, //Add 6 months
				},
				{
					text: "1 year (365 days)",
					value: 31556952000, //Add 1 year
				},
			]
		},
		modalOpen: {
			get() {
				return (
					this.$store.getters[
						"connections/invitationcodes/getAuditorInvitationCodeModalOpen"
					] === true
				)
			},
			set(c) {
				this.setAuditorInvitationCodeModalOpen(c)
			},
		},
	},
	methods: {
		codeCreated(code) {
			this.$emit("updateInvitationCode", code)
		},
		createCode() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			this.setCreatedInvitationCode({ invitationcode: null })
			InvitationcodeAPI.createInvitationCode(
				this.expiry,
				this.name,
				this.multipleRedeem
			)
				.then((result) => {
					this.$store.dispatch("loading/" + LoadingState.ACTION_END_LOADING, {
						root: true,
					})
					this.setCreatedInvitationCode({
						invitationcode: result.invitationCode,
					})
					this.codeCreated(result.invitationCode)
					this.modalOpen = false
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		...mapActions("connections/invitationcodes", [
			"setCreatedInvitationCode",
			"setAuditorInvitationCodeModalOpen",
		]),
	},
}
</script>

<style></style>
